export default __webpack_public_path__ + "static/media/about3.9d8e1ad7.png";